module.exports = __webpack_public_path__ + "e08e4281c6936bb44649b6e00ada5f4b.svg";